import Vue from 'vue';
import Cookies from 'js-cookie';
import ElementUI from 'element-ui';
import './assets/styles/element-variables.scss';
import './assets/styles/pub.scss';


import busEvent from '@/utils/busEvent';
// Echarts
import * as echarts from 'echarts';

// import './permission'; // permission control
import '@/assets/styles/index.scss'; // global css
import '@/assets/styles/ruoyi.scss'; // ruoyi css
import {getDicts} from '@/api/system/dict/data';
// import { getConfigKey } from '@/api/system/config';
import {copyText, parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree, isChild} from '@/utils/ruoyi';
// 分页组件
import Pagination from '@/components/Pagination';
// 自定义表格工具组件
import RightToolbar from '@/components/RightToolbar';
// 富文本组件
import Editor from '@/components/Editor';
// 文件上传组件
import FileUpload from '@/components/FileUpload';
// 图片上传组件
import ImageUpload from '@/components/ImageUpload';
// 图片预览组件
import ImagePreview from '@/components/ImagePreview';
// 字典标签组件
import DictTag from '@/components/DictTag';
// 头部标签组件
import VueMeta from 'vue-meta';
// 字典数据组件
import DictData from '@/components/DictData';
//代码编辑器
import MonacoEditor from '@/components/MonacoEditor';

import App from './App.vue';
import router from './router';
import store from './store';
import plugins from './plugins'; // plugins

import './assets/icons'; // icon

//axios
import axios from 'axios';
import projectDictUtil from "@/utils/projectUtil/projectDictUtil/projectDictUtil";
import productUtil from "@/utils/projectUtil/projectUtil";
// 全局方法挂载
Vue.prototype.getDicts = getDicts;
Vue.prototype.copyText = copyText;
Vue.prototype.parseTime = parseTime;
Vue.prototype.resetForm = resetForm;
Vue.prototype.addDateRange = addDateRange;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.selectDictLabels = selectDictLabels;
Vue.prototype.handleTree = handleTree;
Vue.prototype.$busEvent = busEvent;
Vue.prototype.$axios = axios;
Vue.prototype.$echarts = echarts;
Vue.prototype.isChilds = isChild;
Vue.prototype.projectUtil = productUtil

// 全局组件挂载

Vue.component('DictTag', DictTag);
Vue.component('Pagination', Pagination);
Vue.component('RightToolbar', RightToolbar);
Vue.component('Editor', Editor);
Vue.component('FileUpload', FileUpload);
Vue.component('ImageUpload', ImageUpload);
Vue.component('ImagePreview', ImagePreview);
Vue.component('MonacoEditor', MonacoEditor);

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(plugins);
DictData.install();
new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
